import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AppProvider } from "@/contexts/AppContext";
import { I18nProvider } from "@/lib/i18n";
import { Toaster } from "@/components/ui/sonner";
import { captureUtm } from "@/lib/tracking";

import HomePage from "@/pages/HomePage";
import PricingPage from "@/pages/PricingPage";
import { LoginPage, SignupPage } from "@/pages/AuthPages";
import AuthCallback from "@/pages/AuthCallback";
import ProtectedUser from "@/pages/ProtectedUser";
import OnboardingPage from "@/pages/OnboardingPage";
import DashboardPage from "@/pages/DashboardPage";
import PublicBusinessPage from "@/pages/PublicBusinessPage";
import NotFoundPage from "@/pages/NotFoundPage";

function RouteEffects() {
    const location = useLocation();
    useEffect(() => { captureUtm(); }, []);
    useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);
    return null;
}

function AppRoutes() {
    const location = useLocation();
    // Detect the Google OAuth fragment synchronously during render (prevents race conditions).
    if (location.hash?.includes("session_id=")) return <AuthCallback />;
    return (
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/onboarding" element={<ProtectedUser><OnboardingPage /></ProtectedUser>} />
            <Route path="/dashboard" element={<ProtectedUser><DashboardPage /></ProtectedUser>} />
            <Route path="/b/:slug" element={<PublicBusinessPage />} />
            <Route path="/example" element={<Navigate to="/b/royal-garments" replace />} />
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
}

function App() {
    return (
        <I18nProvider>
            <AppProvider>
                <div className="App">
                    <BrowserRouter>
                        <RouteEffects />
                        <AppRoutes />
                    </BrowserRouter>
                    <Toaster richColors position="top-center" />
                </div>
            </AppProvider>
        </I18nProvider>
    );
}

export default App;
